'use client';

import Image from 'next/image';
import { FC, useEffect, useRef } from 'react';

import { ModalMenuData } from '@/components/ModalProvider/MenuNavigationModal/types';
import { RecommendSectionDto } from '@/components/Partnership/Recommend/types';
import AnimatedButton from '@/components/shared/AnimatedButton';
import useLoader from '@/hooks/useLoader';
import { useModal } from '@/hooks/useModal';
import { gsap } from '@/lib/gsap';

import css from './style.module.scss';
import { ContactUsDto } from './types';

interface Props {
	data: ContactUsDto;
	cta?: { text: string; url: string };
	id?: string;
	dataRecommend?: RecommendSectionDto;
	navigation?: ModalMenuData;
}

const Header: FC<Props> = ({ data, cta, id, dataRecommend, navigation }) => {
	const { isPageReady } = useLoader();
	const logoRef = useRef<HTMLAnchorElement>(null);
	const contactButton = useRef<HTMLDivElement>(null);
	const menuButton = useRef<HTMLDivElement>(null);
	const { openModal } = useModal();

	const ctaHandler = () => {
		if (dataRecommend) openModal('RECOMMEND_US', { data: dataRecommend });
		else openModal('CONTACT_US', { data });
	};

	useEffect(() => {
		const button = contactButton.current;
		const menuBtn = menuButton.current;
		const logo = logoRef.current;

		if ((!button || !logo || !menuBtn) && !isPageReady) return;

		gsap.to([button, logo, menuBtn], {
			opacity: 1,
			delay: 2,
			duration: 0.5
		});
	}, [isPageReady]);

	return (
		<header id={id}>
			<a ref={logoRef} href="/" className={css.logo}>
				<Image width={90} height={20} alt="qream logo" src="/assets/images/logo.svg" />
			</a>

			{navigation ? (
				<div ref={menuButton} className={css.menuButtonWrapper}>
					<AnimatedButton
						className={css.menuButton}
						classNameText={css.menuButtonText}
						onClick={() => openModal('MENU_NAVIGATION', { data: navigation })}
					>
						Menu
					</AnimatedButton>
				</div>
			) : null}

			<div ref={contactButton} className={css.contactButtonWrapper}>
				<AnimatedButton
					className={css.contactButton}
					classNameText={css.contactButtonText}
					onClick={ctaHandler}
				>
					{cta?.text || 'contact us'}
				</AnimatedButton>
			</div>
		</header>
	);
};

export default Header;
